/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
// css
import { Button } from '@styles/button.style'
import { useOnMount } from '@utils/reactExt'
import { Schema$GameBanner } from '@interface/common'
import _ from 'lodash'

export const MatchupListBannerStyle = css`
  width: calc(100% - 28px);
  min-height: 77px;
  border-radius: 8px;
  overflow: hidden;
  margin: 8px 14px;
  > img {
    width: 100%;
    object-fit: contain;
  }
`

const MatchUpListBanner: React.FC = observer((): React.ReactElement => {
  const { globalStore, componentStore } = useRootStore()
  const { matchupListBanners } = componentStore

  const [shuffledFirstBanner, setShuffledFirstBanner] = useState(null)
  const [isBannerLoaded, setIsBannerLoaded] = useState(false)

  useOnMount(() => {
      componentStore.fetchMatchupListBanners().then(() => {
        setIsBannerLoaded(true)
      }).catch(err => console.error(err))
    },
  )

  const getFirstBanner = (banners: Schema$GameBanner[]): Schema$GameBanner => {
    if (banners.length > 1) {
      const shuffledBanners = _.shuffle([...matchupListBanners])
      return shuffledBanners[0]
    } else {
      return banners[0]
    }
  }

  useEffect(() => {
    if (matchupListBanners && matchupListBanners.length > 0) {
      const firstBanner = getFirstBanner(matchupListBanners)
      setShuffledFirstBanner(firstBanner)
    }
  }, [isBannerLoaded])

  const onClickAdvNoticePopup = (): void => {
    if (shuffledFirstBanner.contentsImageUrl) {
      componentStore.setSelectedGameBanner(shuffledFirstBanner)
      globalStore.setVisibleMatchupBanner(true)
    }
  }

  return (
    shuffledFirstBanner ? (
      <Button
        noRadius
        TP
        css={MatchupListBannerStyle}
        onClick={(): void => {
          onClickAdvNoticePopup()
        }}
      >
        <img
          src={shuffledFirstBanner.homeImageUrl}
          alt={shuffledFirstBanner.desc}
        />
      </Button>
    ) : (
      <Fragment/>
    )
  )
})

export default MatchUpListBanner
